import BaseService from './BaseService';

class ContactService extends BaseService {
    getContactForm = () => this.get('/get-contact-form');

    submitContactForm = (formData) => this.post('/submit-contact-form', formData);
}

export default new ContactService();
